exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-50-x-js": () => import("./../../../src/pages/50x.js" /* webpackChunkName: "component---src-pages-50-x-js" */),
  "component---src-pages-coming-js": () => import("./../../../src/pages/coming.js" /* webpackChunkName: "component---src-pages-coming-js" */),
  "component---src-templates-types-js": () => import("./../../../src/templates/types.js" /* webpackChunkName: "component---src-templates-types-js" */)
}

